<template>
	<v-form ref="form">

		<v-layout>
			<v-flex xs4>
				<egranty-text-input-field
					prepend-icon="assignment"
					label="Numer dokumentu"
					for="invoice-form-document-number"
					id="invoice-form-document-number"
					v-model="invoice.documentNumber"
					:max-length="1000">
				</egranty-text-input-field>
			</v-flex>
			<v-flex xs4>
				<egranty-text-input-field
					prepend-icon="assignment"
					label="Rodzaj dokumentu"
					for="invoice-form-document-name"
					id="invoice-form-document-name"
					v-model="invoice.documentName"
					:max-length="1000">
				</egranty-text-input-field>
			</v-flex>
		</v-layout>
		<v-layout>
			<v-flex xs4>
				<egranty-date-picker
					v-model="invoice.documentDate"
					label="Data wystawienia dokumentu"
					required
				/>
			</v-flex>
			<v-flex xs4 style="padding-left: 50px">
				<egranty-number-input-field
					label="Wartość całkowita dokumentu"
					v-model="invoice.totalValue"
				/>
			</v-flex>
		</v-layout>

		<invoice-form-costs v-if="!isNew" :invoice="invoice"/>

		<invoice-form-payment-dates v-if="!onlyOwnContribution" :invoice="invoice"/>

		<egranty-validation-warning
			style="page-break-inside: avoid"
			v-for="warning in warnings"
			:key="warning"
			:warning="warning"
		/>

		<egranty-validation-error
			style="page-break-inside: avoid"
			v-for="(error) in errors"
			:key="error"
			:error="error"
		/>

		<v-card-actions>
			<v-btn @click="primaryAction" class="ma-2" :loading="loading" :disabled="loading">
				<v-icon class="mr-1 white--text">check</v-icon>
				{{ primaryButtonCaption }}
			</v-btn>
		</v-card-actions>
	</v-form>
</template>

<script>
	import EgrantyTextInputField from "../../../../genericComponents/EgrantyTextInputField";
	import InvoiceFormPaymentDates from "./InvoiceFormPaymentDates";
	import InvoiceFormCosts from "./InvoiceFormCosts";
	import EgrantyDatePicker from "../../../../genericComponents/EgrantyDatePicker";
	import EgrantyNumberInputField from "../../../../genericComponents/EgrantyNumberInputField";
	import EgrantyValidationError from "../../../../genericComponents/EgrantyValidationError";
	import {Numbers} from "../../../../utils/Numbers";
	import {Project} from "../../../../api/generated/Project";
	import EgrantyValidationWarning from "../../../../genericComponents/EgrantyValidationWarning";
	import {Invoice} from "../../../../api/generated/Invoice";
  import {Api} from "@/api";

	export default {
		name: "InvoiceForm",

		components: {
			EgrantyValidationWarning,
			EgrantyValidationError,
			EgrantyNumberInputField,
			EgrantyDatePicker, InvoiceFormCosts, InvoiceFormPaymentDates, EgrantyTextInputField,
		},

		data() {
			return {
				projectDates: null,
        projectTerms: null,
				required: v => !!v || "To pole jest wymagane",
				errors: [],
				projectActionsCosts: [],
				projectAdministrativeCosts: [],
				warnings: [],
				dataLoaded: false,

				invoicesRequestedDotation: 0,
				projectRequestedDotation: 0,
			};
		},

		computed: {

			dotationBalance () {
				let invoicesRequestedDotation = this.invoicesRequestedDotation + this.currentInvoiceDotationSum;
				return this.projectRequestedDotation - invoicesRequestedDotation;
			},

			onlyOwnContribution() {
				for (let cost of this.invoice.actionCosts) {
					for (let division of cost.costDivisions) {
						if (division.financialSource !== "OWN_HUMAN_CONTRIBUTION" && division.financialSource !== "OWN_CONTRIBUTION_IN_KIND") {
							return false;
						}
					}
				}
				return true;
			},

			currentInvoiceDotationSum () {
				let sum = 0;
				for (let cost of this.invoice.actionCosts) {
					for (let division of cost.costDivisions) {
						if (division.financialSource === "DOTATION") {
							if (typeof division.value !== "number") {
								sum += Number.parseFloat(division.value);
							} else {
								sum += division.value;
							}
						}
					}
				}
				return sum;
			},

			totalSum() {
				let sum = 0;
				for (let cost of this.invoice.actionCosts) {
					for (let division of cost.costDivisions) {
						if (typeof division.value !== "number") {
							sum += Number.parseFloat(division.value);
						} else {
							sum += division.value;
						}
					}
				}
				return sum;
			}
		},

		watch: {
			invoice: {
				deep: true,
				handler(val) {
					this.errors = [];
					this.invoice = val;
					if (!this.dataLoaded) {
						this.dataLoaded = true;
						this.loadComponentData(val);
					}
					this.validateWarnings();
				}
			},
		},

		props: {
			isNew: {},
			invoice: {
				type: Object, default: () => {
				}, required: true,
			},
			primaryButtonCaption: {type: String, default: "Zapisz"},
			loading: {type: Boolean, default: false}
		},

		mounted () {
			if (this.isNew) {
				this.loadComponentData(this.invoice);
				this.dataLoaded = true;
			}
		},

		methods: {
			loadComponentData (invoice) {
				this.loadProjectData(invoice.projectId);
				this.loadInvoicesGeneralInfo(invoice.projectId);
				this.loadProjectGeneralInfo(invoice.projectId);
			},

			validateWarnings() {
				if (!this.projectDates || !this.projectTerms) {
					return;
				}
				this.warnings = [];

				let date = this.invoice.documentDate;
        let paymentDates = this.invoice.paymentDates;
				if (date < this.projectDates.start || date > this.projectDates.end) {
					this.warnings.push("Data wystawienia dokumentu " + date + " wykracza poza okres realizacji projektu ");
				}
        if ((this.projectTerms.donationFrom && (date < this.projectTerms.donationFrom))
            || (this.projectTerms.donationTo && (date > this.projectTerms.donationTo))) {
          this.warnings.push("Data wystawienia dokumentu " + date + " wykracza poza termin wykorzystania dotacji ");
        }
        if ((this.projectTerms.contributionFrom && (date < this.projectTerms.contributionFrom))
            || (this.projectTerms.contributionTo && (date > this.projectTerms.contributionTo))) {
          this.warnings.push("Data wystawienia dokumentu " + date + " wykracza poza termin wykorzystania wkładu własnego ");
        }
        paymentDates.filter(payment => payment.date).forEach(payment => {
          if ((this.projectTerms.donationFrom && (payment.date < this.projectTerms.donationFrom))
              || (this.projectTerms.donationTo && (payment.date > this.projectTerms.donationTo))) {
            this.warnings.push("Data płatności dokumentu " + payment.date + " wykracza poza termin wykorzystania dotacji ");
          }
          if ((this.projectTerms.contributionFrom && (payment.date < this.projectTerms.contributionFrom))
              || (this.projectTerms.contributionTo && (payment.date > this.projectTerms.contributionTo))) {
            this.warnings.push("Data płatności dokumentu " + payment.date + " wykracza poza termin wykorzystania wkładu własnego ");
          }
          if (date > payment.date) {
            this.warnings.push("Data płatności dokumentu " + payment.date + " jest wcześniejsza niż data wystawienia ");
          }
        });
				if (parseFloat(this.dotationBalance.toFixed(2)) < 0) {
					this.warnings.push("Suma kwoty dotacji z projektu została przekroczona");
				}
			},

			loadProjectGeneralInfo (projectId) {
				let id = this.$route.params.projectId || projectId;
				Project.getPublicBasicData(this, id, (result) => {
					this.projectRequestedDotation = result.requestedProjectDotation;
					this.validateWarnings();
				});
			},

			loadInvoicesGeneralInfo (projectId) {
				let id = this.$route.params.projectId || projectId;
				Invoice.getGeneralInfo(this, id, (result) => {
					for (const invoice of result) {
						if (invoice.id !== this.invoice.id) {
							this.invoicesRequestedDotation += invoice.fromDotation;
						}
					}
					this.validateWarnings();
				});
			},

			loadProjectData (projectId) {
				let id = this.$route.params.projectId || projectId;
				Project.get(this, id, (result) => {
					this.projectDates = result.dates;
          this.projectTerms = result.terms;
					this.projectActionsCosts = result.actionCosts;
					this.projectAdministrativeCosts = result.administrativeCosts;
					this.validateWarnings();
				});
			},

      async syncGetIsNumberTaken(projectId, callback) {
        await Api.syncGet(this, "/invoice/is-number-taken"
            + "?projectId=" + projectId
            + "&documentNumber=" + this.invoice.documentNumber
            + (this.$route.params.invoiceId ? ("&invoiceId=" + this.$route.params.invoiceId) : ""),
            callback);
      },

			async validate() {
        this.errors = [];

        if (!await this.$refs.form.validate()) {
          this.errors.push("Proszę o uzupełnienie wymaganych pól");
        }
        if (!this.onlyOwnContribution && this.invoice.paymentDates.length === 0) {
          this.errors.push("Proszę o podanie conajmniej jednego terminu płatności");
        }
        if (this.errors.length !== 0) {
          return false;
        }

        let totalProvidedSumNumber = Number.parseFloat(this.invoice.totalValue);

        if (parseFloat(this.totalSum.toFixed(2)) > parseFloat(totalProvidedSumNumber.toFixed(2))) {
          return await this.$confirm("Suma podanych kosztów (" + Numbers.methods.formatCurrency(this.totalSum) + " PLN) " +
              "jest większa od podanej całkowitej kwoty dokumentu. Czy na pewno chcesz zapisać dokument?", {
            color: "info",
            icon: "warning",
            title: "Zapisanie dokumentu",
            width: 500,
          });
        }

        let documentNumberTaken = false;

        await this.syncGetIsNumberTaken(this.$route.params.projectId || this.invoice.projectId, (result) => {
          documentNumberTaken = result;
        });

        if (!documentNumberTaken) {
          return true;
        }

        return await this.$confirm("Dokument o takim numerze został już wprowadzony. " +
            "Dodaj dokument jedynie w przypadku, gdy jest to inny dokument o takim samym numerze.", {
          color: "info",
          icon: "warning",
          title: "Zapisanie dokumentu",
          width: 500,
          buttonTrueText: "Dodaj mimo to",
          buttonFalseText: "Anuluj wprowadzanie",
        });
			},

			primaryAction() {
				if (this.onlyOwnContribution) {
					this.invoice.paymentDates = [];
				}
				this.$emit("primary-action", this.invoice);
			},
		},
	};
</script>

